export const entityCreationObject = (data) => {
  let objectTemp = {
    name: data.name,
    type: data.type,
    website_url: data?.website_url,
    facebook_url: data?.facebook_url,
    linkedin_url: data?.linkedin_url,
    instagram_url: data?.instagram_url,
    instagram_username: data?.instagram_username,
    twitter_url: data?.twitter_url,
    twitter_username: data?.twitter_username,
    whatsapp: data?.whatsapp,
    city_id: data?.city_id,
  };

  return objectTemp;
};

export const getEntityUpdatenObject = (data) => {
  let objectTemp = {
    name: data.name,
    type: data.type,
    website_url: data?.website_url,
    facebook_url: data?.facebook_url,
    linkedin_url: data?.linkedin_url,
    instagram_url: data?.instagram_url,
    instagram_username: data?.instagram_username,
    twitter_url: data?.twitter_url,
    twitter_username: data?.twitter_username,
    whatsapp: data?.whatsapp,
    city_id: data?.city_id,
  };

  return objectTemp;
};
